import React from 'react';
import LayersAndResolutions from 'data/layers/LayersAndResolutions.json';

const GradientLegend = ({ colors }) => {

    // We calculate the quantity of steps for the gradient to distribute the numbers.
    const totalSteps = colors.length - 1;
    const gradientColors = colors.map((color) => color.color);   

    return (
        <div style={{ padding: '20px 10px', position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

            <div style={{
                background: `linear-gradient(to left, ${gradientColors.join(',')})`, // Fake horizontal gradient.
                height: '30px',
                width: '300px',
                borderRadius: '5px',
                border: '1px solid #ccc',
                position: 'relative',
                marginBottom: '20px'
            }}>
                
                {
                    // We add small arrows, alternating below and above the gradient.
                    colors.slice().reverse().map((item, index) => {
                        const position = (index / totalSteps) * 100; //We calculate the position (in percentages) of the current arrow. 

                        return (
                            <span key={index} style={{
                                position: 'absolute',
                                left: `${position}%`,
                                color: 'white',
                                fontWeight: 'bold',
                                fontSize: '10px',
                                whiteSpace: 'nowrap',
                                transform: 'translateX(-50%)',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                marginTop: index % 2 === 0 ? '-40px' : '5px',
                            }}>
                                <span style={{
                                    width: 0,
                                    height: 0,
                                    borderLeft: '5px solid transparent',
                                    borderRight: '5px solid transparent',
                                    borderTop: index % 2 === 0 ? '5px solid black' : 'none',  // Arrow aiming downwards, on top of the gradient.
                                    borderBottom: index % 2 === 0 ? 'none' : '5px solid black',  // Arrow aiming upwards, below the gradient.
                                    marginBottom: index % 2 === 0 ? '-30px' : '5px',  // Reduced the space below the inferior arrows.
                                    marginTop: index % 2 === 0 ? '39px' : '20px',
                                }}></span>
                                {item.value}
                            </span>
                        );
                    })
                }
            </div>

        </div>
    );
};

export default GradientLegend;
